import React, { ReactNode } from 'react';
import { DataGridCellBaseProps } from '../../DataGridCell.types';


export type DataGridLinkCellProps = {};

export interface DataGridLinkCellBaseProps
  extends Omit<DataGridCellBaseProps, 'value'> {
  value: {
    href: string;
    text: string;
  };
}

export const DataGridLinkCell: React.FC<DataGridLinkCellBaseProps> = ({
  value: { href, text },
}) => {
  return <a href={href}>{text}</a>;
};
